import DigitalPlatform1 from './DigitalPlatform1';

export default DigitalPlatform1;
